import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import Card from "./component/card";
import { conversion_list } from "../exChange/ajax";
import { getCurrentUid } from "@/api/common";
import { Loading } from "@xp-design/mobile";
import { unixTimestamp } from "@/utils/time";
import img_empty from "@/assets/img_empty.png";
import { debounce } from "@/utils/common";
import PageContainer from "@/component/pageContainer";
import { processOssImage } from "@/utils/image";

interface CardData {
  exchangeItemName: string;
  conversionCodeStatusName: string;
  conversionCodeCode: string;
  verificationCompletionTime?: string;
  remark?: string;
  exchangeProductCode: string;
  exchangeItemId: string;
  exchangeProductSmallCode?: string;
}

const App: React.FC = () => {
  const [cardsData, setCardsData] = useState<CardData[]>([]);
  const contentRef = useRef<HTMLDivElement>(null);
  const [pageNo, setPageNo] = useState(1);
  const [hasMore, setHasMore] = useState(true); // 是否还有更多数据
  const pageSize = 100;

  const fetchInitialData = async ({ pageNo }) => {
    try {
      Loading.show("请求中...");
      const userUid = await getCurrentUid();
      console.log("userUid------------", userUid);
      const param = {
        conversionCodeStatusCode: "10,20",
        userUid,
        redirectUrl: "http://chargegateway.test.xiaopeng.local",
        pageSize,
        pageNo,
      };
      const { records, total } = await conversion_list(param);
      setPageNo(pageNo);
      const formattedData = records.map((item) => ({
        ...item,
        verificationCompletionTime: unixTimestamp(
          item.verificationCompletionTime,
        ),
      }));
      cardsData.push(...formattedData);
      setCardsData([...cardsData]);
      setHasMore(total > cardsData.length);
    } catch (error) {
      console.error("Failed to fetch cards data:", error);
    } finally {
      Loading.hide();
    }
  };

  useEffect(() => {
    fetchInitialData({ pageNo });
    // const exchangeCarList=sessionStorage.getItem('exchangeCardList')

    // if(exchangeCarList){
    //   const {records,total}=JSON.parse(exchangeCarList)

    //   setPageNo(1)
    //   const formattedData = records?.map(item => ({
    //     ...item,
    //     verificationCompletionTime: unixTimestamp(item.verificationCompletionTime)
    //   })) || [];
    //   cardsData.push(...formattedData)

    //   setCardsData([...cardsData]);
    //   try{
    //     setHasMore(total > cardsData.length);
    //   }catch(err){
    //     setHasMore(false)
    //   }
    // }else{
    //   fetchInitialData({ pageNo });
    // }
    // return ()=>{
    //   sessionStorage.removeItem("exchangeCardList")
    // }
  }, []);

  useEffect(() => {
    // 添加滚动事件监听器
    const handleScroll = debounce(() => {
      const contentElement = contentRef.current;
      if (contentElement) {
        const scrollTop = contentElement.scrollTop;
        const scrollHeight = contentElement.scrollHeight;
        const clientHeight = contentElement.clientHeight;
        if (scrollTop + clientHeight >= scrollHeight - 200) {
          console.log("scroll to bottom");
          if (hasMore) {
            fetchInitialData({ pageNo: pageNo + 1 });
          }
        }
      }
    }, 300);

    const contentElement = contentRef.current;
    if (contentElement) {
      contentElement.addEventListener("scroll", handleScroll);
    }
    // 清理事件监听器
    return () => {
      if (contentElement) {
        contentElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, [pageNo]);
  return (
    <PageContainer title="兑换记录">
      <div ref={contentRef} className={`exchange_page wrapExchangeDetail`}>
        <div className="mainContent mainContent1 ">
          {cardsData.map((card, index) => (
            <Card
              key={index}
              exchangeItemName={card.exchangeItemName}
              conversionCodeStatusName={card.conversionCodeStatusName}
              conversionCodeCode={card.conversionCodeCode}
              verificationCompletionTime={card.verificationCompletionTime}
              remark={card.remark}
              exchangeProductCode={card.exchangeProductCode}
              exchangeItemId={card.exchangeItemId}
              exchangeProductSmallCode={card.exchangeProductSmallCode}
            />
          ))}
          {cardsData.length === 0 && (
            <div className="noData">
              <img src={processOssImage(img_empty)} alt="empty" />
              暂无兑换记录
            </div>
          )}
          {!hasMore && cardsData.length > 0 && (
            <div className="endMessage">没有更多数据了</div>
          )}
        </div>
      </div>
    </PageContainer>
  );
};

export default App;
